<template>
  <draggable tag="tbody" :animation="200" :disable="!draggable" draggable=".item" handle=".item-handle" v-if="searched.length > 0" class="body-group" @end="moveHandler">
    <slot name="ontop" :items="searched" :headers="headers" :expanded="expanded" :expand="expand" :fold="fold" :filtered="searched.length < items.length"/>
    <tr v-for="(item, row) in searched" :key="item.id" v-ripple class="item" :class="{hidden: !expanded}">
      <slot name="row" :headers="headers" :items="items" :row="row">
        <td v-for="(header, col) in headers" :key="col" :style="`text-align: ${header.align || 'left'}`">
          <slot :name="`col:${header.value}`" :item="item" :header="header" :row="row" :col="col" :resolveData="resolveData" :filtered="searched.length < items.length">
            {{resolveData(item, header.value)}}
          </slot>
        </td>
      </slot>
    </tr>
    <slot name="onbottom" :items="searched" :headers="headers" :expanded="expanded" :expand="expand" :fold="fold"/>
  </draggable>
  <!-- <tbody v-else>
    <tr>
      <td :colspan="headers.length">{{ no_data_text }}</td>
    </tr>
  </tbody>   -->
</template>

<script>
import loader_mixin from './loader_mixin'
import draggable from 'vuedraggable'
export default {
  props: {
    items: Array
  },
  data: () => ({
    expanded: true
  }),
  mixins: [loader_mixin],
  methods: {
    moveHandler(evt) {
      if (evt.oldDraggableIndex == evt.newDraggableIndex) return
      this.$emit('dragged', {
        from: this.items[evt.oldDraggableIndex],
        to: this.items[evt.newDraggableIndex]
      })
    },
    resolveData(item, address) {
      return address.split('.').reduce((prev, cur) => prev[cur], item)
    },
    expand(){
      this.expanded = true
    },
    fold(){
      this.expanded = false
    }
  },
  computed: {
    searched(){
      return this.items.filter(this.search)
    },
  },
  components: {
    draggable
  }
}
</script>

<style>
.hidden {
  display: none;
}
</style>